// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2xcvM","head":"ProcedureTableInfo_head__19U3-"};